import Pqp from "../3x1010/Pqp.js";
import Globals from "../Globals.js";

export default class PageCommon {
    constructor() {}
    init() {}

    showPreloader(flag) {
        if (flag) {
            jQuery(".mainApp").hide();
            jQuery(".js-preloader").show();
        } else {
            jQuery(".mainApp").show();
            jQuery(".js-preloader").hide();
        }
    }

    track() {
        if (Globals.SHOW_TRACKING_DATA) {
            if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("---tracking---");
            if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("Event: " + PageCommon._normalizza_track_prop(o.event));
            if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("Category: " + PageCommon._normalizza_track_prop(o.category));
            if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("Label: " + o.label ? PageCommon._normalizza_track_prop(o.label) : "n/a");
        }

        let additional = {
            event_category: PageCommon._normalizza_track_prop(o.category),
        };
        if (o.label) {
            additional.event_label = PageCommon._normalizza_track_prop(o.label);
        }

        gtag("event", PageCommon._normalizza_track_prop(o.event), additional);
    }

    _normalizza_track_prop(s) {
        let ret = s.toLowerCase();
        //  ret = Pqp.safeReplace(ret, " ", "_");
        ret = Pqp.safeReplace(ret, "/", "-");
        ret = Pqp.safeReplace(ret, " ", "-");
        ret = Pqp.safeReplace(ret, "#", "");
        ret = Pqp.safeReplace(ret, "'", "_");
        ret = Pqp.safeReplace(ret, ".", "");
        ret = Pqp.safeReplace(ret, ",", "");
        ret = Pqp.safeReplace(ret, ";", "");
        ret = Pqp.safeReplace(ret, "<", "");
        ret = Pqp.safeReplace(ret, ">", "");
        ret = Pqp.safeReplace(ret, "(", "_");
        ret = Pqp.safeReplace(ret, ")", "");
        ret = Pqp.safeReplace(ret, "__", "_");
        ret = Pqp.safeReplace(ret, "?", "");
        ret = Pqp.safeReplace(ret, "&", "-");
        return ret;
    }

    decodeHtmlEntity(str) {
        return str.replace(/&#(\d+);/g, function (match, dec) {
            return String.fromCharCode(dec);
        });
    }

    encodeHtmlEntity(str) {
        var buf = [];
        for (var i = str.length - 1; i >= 0; i--) {
            buf.unshift(["&#", str[i].charCodeAt(), ";"].join(""));
        }
        return buf.join("");
    }

    // Shuffle an array of elements
    shuffle(a) {
        for (let i = a.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [a[i], a[j]] = [a[j], a[i]];
        }
        return a;
    }

    // Slice firsts N words
    sliceWords(str, words) {
        if (str === null) return;
        return str
            .split(" ")
            .filter((_, index) => index < words)
            .join(" ");
    }

    formatPrice(price) {
        var value = Number(price);
        value = value.toFixed(2);
        return value;
    }

    // Emit an event
    emitEvent(eventName, data, target) {
        const event = new CustomEvent(eventName, data);
        if (target) {
            return target.dispatchEvent(event);
        }
        return document.dispatchEvent(event);
    }

    // COOKIES MANAGER
    setCookie(cname, token) {
        const d = new Date();
        d.setTime(d.getTime() + 1 * 24 * 60 * 60 * 1000);
        const expires = d.toUTCString();
        document.cookie = `${cname}=${token}; expires=${expires}; path=/`;
    }

    getCookie(cname) {
        const name = `${cname}=`;
        const decodedCookie = decodeURIComponent(document.cookie);
        const ca = decodedCookie.split(";");
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == " ") {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

    deleteCookie(cname) {
        document.cookie = `${cname}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
    }

    // URL QUERY
    getUrlParams() {
        const queryString = window.location.search;
        return new URLSearchParams(queryString);
    }
    setUrlParams(page, array) {
        let pathname = window.location.pathname.split("/");
        pathname.pop();
        pathname = pathname.join("/");
        let baseUrl = `${window.location.origin}${pathname}/${page}`;
        if (page.startsWith("/")) baseUrl = `${window.location.origin}${page}`;
        const url = new URL(baseUrl);
        const urlParams = new URLSearchParams(url.search);
        array.map(({ key, value }) => urlParams.append(key, value));
        if (urlParams.toString() === "") {
            return `${url}`;
        } else {
            return `${url}?${urlParams.toString()}`;
        }
    }

    // FETCHING
    handleResponse(response) {
        return response.text().then((text) => {
            const data = text && JSON.parse(text);

            if (!response.ok) {
                if ([401, 403].includes(response.status)) {
                    this.deleteCookie("user_token");
                }

                const error = (data && data.message) || response.statusText;
                return Promise.reject(error);
            }

            return data;
        });
    }

    // KEYCODE
    getKeyCode(event) {
        let code;
        if (event.key !== undefined) {
            code = event.key;
        } else if (event.keyIdentifier !== undefined) {
            code = event.keyIdentifier;
        } else if (event.keyCode !== undefined) {
            code = event.keyCode;
        }
        if (code === 13) {
            code = "Enter";
        } else if (code === 24) {
            code = "ArrowUp";
        } else if (code === 25) {
            code = "ArrowDown";
        } else if (code === 37) {
            code = "ArrowLeft";
        } else if (code === 39) {
            code = "ArrowRight";
        } else if (code === " " || code === 32) {
            code = "Space";
        }
        return code;
    }

    // Player
    getMouseCoordinate(event, wave) {
        let x = parseInt(event.pageX - wave.getBoundingClientRect().left);
        let y = parseInt(event.pageY - wave.getBoundingClientRect().top);
        return { x, y };
    }
    formatTime(time) {
        let s = parseInt(time % 60);
        let m = parseInt((time / 60) % 60);
        return m.toLocaleString("en-US", { minimumIntegerDigits: 2 }) + ":" + s.toLocaleString("en-US", { minimumIntegerDigits: 2 });
    }

    // Download
    download(url) {
        var element = document.createElement("a");
        element.href = url;

        const filename = url.split("/").pop();
        element.download = filename;
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
    }

    extractDate(string) {
        const year = string.substr(0, 4);
        const month = string.substr(4, 2);
        const day = string.substr(6, 2);
        const hour = string.substr(8, 2);
        const minute = string.substr(10, 2);
        const second = string.substr(12, 2);
        return new Date(`${year}-${month}-${day} ${hour}:${minute}:${second}`);
    }
    formatDate(date) {
        const day = date.getDate();
        const month = date.toLocaleString("en-US", { month: "long" });
        const year = date.getFullYear();
        return `${month} ${day}, ${year}`;
    }

    b64toBlob(b64Data, contentType, sliceSize) {
        contentType = contentType || "";
        sliceSize = sliceSize || 512;

        var byteCharacters = atob(b64Data);
        var byteArrays = [];

        for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            var slice = byteCharacters.slice(offset, offset + sliceSize);

            var byteNumbers = new Array(slice.length);
            for (var i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }

            var byteArray = new Uint8Array(byteNumbers);

            byteArrays.push(byteArray);
        }

        var blob = new Blob(byteArrays, { type: contentType });
        return blob;
    }

    cleanInput(str) {
        let regex = /[#]/g;
        return str.replace(regex, function (match) {
            if (match === "#") {
                return "";
            } else {
                return "";
            }
        });
    }

    requestDownload(userManager, track) {
        if (userManager.userLogged) {
            const token = this.getCookie("user_token");
            if (!token) {
                return false;
            }
            document.querySelector("#genericStatusModal .medium-title").textContent = "DOWNLOAD";
            document.querySelector("#genericStatusModal .message").textContent = "Please wait..";
            jQuery("#genericStatusModal").modal("show");
            fetch(`${Globals.WS_URL}?mode=TRACK.DOWNLOAD&token=${token}&track_id=` + track.ID)
                .then(this.handleResponse)
                .then((result) => {
                    if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("Track - Download");
                    if (result.download.enabled) {
                        this.download(result.download.url);
                        document.querySelector("#genericStatusModal .message").textContent = "Downloaded";
                        setTimeout(() => {
                            document.querySelector("#genericStatusModal .medium-title").textContent = "";
                            document.querySelector("#genericStatusModal .message").textContent = "";
                            jQuery("#genericStatusModal").modal("hide");
                        }, 2000);
                    } else {
                        // document.querySelector("#genericStatusModal .message").textContent = "Reached downloads limit";
                        // setTimeout(() => {
                        //     document.querySelector("#genericStatusModal .medium-title").textContent = "";
                        //     document.querySelector("#genericStatusModal .message").textContent = "";
                        //     jQuery("#genericStatusModal").modal("hide");
                        // }, 2000);
                        window.location.href = "/licenses?force-track=" + track.ID;
                    }
                })
                .catch((error) => {
                    if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("ERROR Track - Download", { message: error.message });
                    document.querySelector("#genericStatusModal .message").textContent = "Error: " + error.message;
                    setTimeout(() => {
                        document.querySelector("#genericStatusModal .medium-title").textContent = "";
                        document.querySelector("#genericStatusModal .message").textContent = "";
                        jQuery("#genericStatusModal").modal("hide");
                    }, 2000);
                });
            gtag("event", track.Name + " {" + track.ID + "}", { event_category: "download", event_label: "Download" });
        }
    }

    shareItem(element, data) {
        document.querySelector("#genericStatusModal .medium-title").textContent = "SHARE";
        document.querySelector("#genericStatusModal .message").textContent = "";
        jQuery("#genericStatusModal").modal("show");

        let text = "";
        if (element === "album") {
            text = data.Name;
        } else if (element === "artist") {
            text = data.Name;
        } else if (element === "label") {
            text = data.Name;
        } else if (element === "playlist") {
            text = data.Name;
        }

        var shares = [
            {
                share: "email",
                logo: "fas fa-at",
                label: "E-mail",
                text: text,
            },
            {
                share: "twitter",
                logo: "fab fa-twitter",
                label: "Twitter",
                text: "#" + text,
            },
            {
                share: "facebook",
                logo: "fab fa-facebook-f",
                label: "Facebook",
                text: text,
            },
        ];

        jQuery("#genericStatusModal .message").jsSocials({
            url: window.location.href,
            shareIn: "popup",
            shares,
            showLabel: true,
            on: {
                click: function (e) {
                    setTimeout(() => {
                        document.querySelector("#genericStatusModal .medium-title").textContent = "";
                        document.querySelector("#genericStatusModal .message").textContent = "";
                        jQuery("#genericStatusModal").modal("hide");
                    }, 2000);
                },
                error: (err) => {
                    document.querySelector("#genericStatusModal .message").textContent = err.message;
                },
            },
        });

        Array.from(document.querySelectorAll("#genericStatusModal .message .jssocials-shares .jssocials-share-link")).map((link) => {
            link.classList.add("btn");
            link.classList.add("btn-sm");
            link.classList.add("btn-primary");
        });

        const copyLink = document.createElement("div");
        copyLink.className = "jssocials-share jssocials-copy-link";
        const link = document.createElement("a");
        link.href = "#";
        link.className = "jssocials-share-link btn btn-sm btn-primary";

        var copyText = document.createElement("textarea");
        copyText.id = "clipboard";
        copyText.style.opacity = "0";
        copyText.style.position = "absolute";
        copyText.textContent = window.location.href;
        document.querySelector("#genericStatusModal").appendChild(copyText);

        link.addEventListener("click", (event) => {
            /* Select the text field */
            copyText.select();
            copyText.setSelectionRange(0, 99999); /* For mobile devices */

            try {
                var successful = document.execCommand("copy");
                var msg = successful ? "LINK COPIED TO CLIPBOARD" : "ERROR";
                document.querySelector("#genericStatusModal .message").textContent = msg;
                setTimeout(() => {
                    document.querySelector("#genericStatusModal .medium-title").textContent = "";
                    document.querySelector("#genericStatusModal .message").textContent = "";
                    jQuery("#genericStatusModal").modal("hide");
                }, 2000);
            } catch (err) {
                document.querySelector("#genericStatusModal .message").textContent = err.message;
            }

            document.querySelector("#genericStatusModal").removeChild(copyText);
        });

        const span = document.createElement("span");
        span.className = "jssocials-share-label";
        span.textContent = "Copy Link";
        link.appendChild(span);

        copyLink.appendChild(link);

        document.querySelector("#genericStatusModal .message .jssocials-shares").appendChild(copyLink);
    }

    socialLogin(social) {
        document.querySelector("#genericStatusModal .medium-title").textContent = "LOGGING IN";
        document.querySelector("#genericStatusModal .message").textContent = "Please wait..";
        jQuery("#genericStatusModal").modal("show");

        // const return_url = window.location.origin + "/find-music";
        const return_url = window.location.href;

        window.location.href = `${Globals.WS_URL}?mode=LOGIN.SOCIAL&social=${social}&return_url=${return_url}`;
    }

    swapLinksToEvents(links, dataStructure, userManager) {
        Array.from(links).map((link) => {
            if (link.href.indexOf("javascript") === -1 && link.href.indexOf("#") === -1 && !link.classList.contains("changed")) {
                const href = link.href.replace(window.location.origin, "").split("/");
                // if (Globals.SHOW_ALL_CONSOLE_LOG) console.log(href, link.href);
                if (href[1].indexOf("?") === -1) {
                    link.dataset.page = href[1];
                } else {
                    link.dataset.page = href[1].replace(/(\?)(.*)/, "");
                    href[2] = href[1];
                }
                if (href[2]) {
                    // if (Globals.SHOW_ALL_CONSOLE_LOG) console.log(href[2]);
                    href[2]
                        .replace(/(.*)(\?)/, "")
                        .split("&")
                        .map((item) => {
                            const fields = item.split("=");
                            link.dataset[fields[0]] = fields[1];
                            // if (Globals.SHOW_ALL_CONSOLE_LOG) console.log(fields, link.dataset, fields[1]);
                        });
                }
                link.classList.add("changed");
                link.addEventListener("click", (event) => {
                    event.preventDefault();
                    const item = event.currentTarget;
                    const page = item.dataset.page;
                    const id = item.dataset.id;
                    const format = item.dataset.format;

                    history.pushState(history.state, document.title, item.href);
                    this.emitEvent(
                        "click",
                        {
                            detail: {
                                disableDefaultSearch: true,
                            },
                        },
                        document.querySelector(".fm-searchbar .reset button")
                    );

                    document.querySelector("#sideMenu").style.display = "";

                    this.resetAllSections();
                    document.querySelector("#tracksSection").style.display = "none";

                    // if (Globals.SHOW_ALL_CONSOLE_LOG) console.log(page, id, format);

                    if (page === "playlists") {
                        document.querySelector("#playlistsListSection").style.display = "";
                        dataStructure.playlists.renderList();
                        const loadedLinks = document.querySelectorAll("#playlistsListSection a");
                        this.swapLinksToEvents(loadedLinks, dataStructure, userManager);
                    } else if (page === "playlist") {
                        document.querySelector("#playlistSection").style.display = "";
                        document.querySelector("#tracksSection").style.display = "";
                        dataStructure.playlists.renderSingle(id, dataStructure.tracks, userManager);
                        document.addEventListener("track_list_loaded", () => {
                            const loadedLinks = document.querySelectorAll("#tracksSection a");
                            this.swapLinksToEvents(loadedLinks, dataStructure, userManager);
                        });
                    } else if (page === "artists") {
                        document.querySelector("#artistsListSection").style.display = "";
                        dataStructure.artists.renderList(format, "artistsList");
                        const loadedLinks = document.querySelectorAll("#artistsListSection a");
                        this.swapLinksToEvents(loadedLinks, dataStructure, userManager);
                    } else if (page === "artist") {
                        document.querySelector("#artistSection").style.display = "";
                        document.querySelector("#tracksSection").style.display = "";
                        dataStructure.artists.renderSingle(id, dataStructure.tracks);
                        const loadedLinks = document.querySelectorAll("#tracksSection a");
                        this.swapLinksToEvents(loadedLinks, dataStructure, userManager);
                    } else if (page === "albums") {
                        document.querySelector("#albumsListSection").style.display = "";
                        dataStructure.albums.renderList();
                        const loadedLinks = document.querySelectorAll("#albumsListSection a");
                        this.swapLinksToEvents(loadedLinks, dataStructure, userManager);
                    } else if (page === "album") {
                        document.querySelector("#albumSection").style.display = "";
                        document.querySelector("#tracksSection").style.display = "";
                        dataStructure.albums.renderSingle(id, dataStructure.tracks);
                        const loadedLinks = document.querySelectorAll("#tracksSection a");
                        this.swapLinksToEvents(loadedLinks, dataStructure, userManager);
                    } else if (page === "labels") {
                        document.querySelector("#labelsListSection").style.display = "";
                        dataStructure.labels.renderList();
                        const loadedLinks = document.querySelectorAll("#labelsListSection a");
                        this.swapLinksToEvents(loadedLinks, dataStructure, userManager);
                    } else if (page === "label") {
                        document.querySelector("#labelSection").style.display = "";
                        document.querySelector("#tracksSection").style.display = "";
                        dataStructure.labels.renderSingle(id, dataStructure.tracks);
                        const loadedLinks = document.querySelectorAll("#tracksSection a");
                        this.swapLinksToEvents(loadedLinks, dataStructure, userManager);
                    }

                    setTimeout(() => {
                        window.scrollTo(0, 0);
                    }, 200);
                });
            }
        });
    }

    resetAllSections() {
        if (document.querySelector("#playlistsSection")) document.querySelector("#playlistsSection").style.display = "none";
        if (document.querySelector("#artistsBlock")) document.querySelector("#artistsBlock").style.display = "none";
        if (document.querySelector("#producersBlock")) document.querySelector("#producersBlock").style.display = "none";
        if (document.querySelector("#albumsBlock")) document.querySelector("#albumsBlock").style.display = "none";
        if (document.querySelector("#labelsBlock")) document.querySelector("#labelsBlock").style.display = "none";

        if (document.querySelector("#playlistsListSection")) document.querySelector("#playlistsListSection").style.display = "none";
        if (document.querySelector("#playlistSection")) document.querySelector("#playlistSection").style.display = "none";
        if (document.querySelector("#artistsListSection")) document.querySelector("#artistsListSection").style.display = "none";
        if (document.querySelector("#artistSection")) document.querySelector("#artistSection").style.display = "none";
        if (document.querySelector("#albumsListSection")) document.querySelector("#albumsListSection").style.display = "none";
        if (document.querySelector("#albumSection")) document.querySelector("#albumSection").style.display = "none";
        if (document.querySelector("#labelsListSection")) document.querySelector("#labelsListSection").style.display = "none";
        if (document.querySelector("#labelSection")) document.querySelector("#labelSection").style.display = "none";

        // setTimeout(() => {
        //     window.setAbsolute();
        // }, 200);
    }

    sendAskusData(userManager, formData) {
        if (userManager.userLogged) {
            const token = this.getCookie("user_token");
            if (!token) {
                return false;
            }

            // if (!Pqp.validateEmail(formData.get("email"))) {
            //     document.querySelector("#genericStatusModal .medium-title").textContent = "ERROR";
            //     document.querySelector("#genericStatusModal .message").textContent = "Email not valid";
            //     jQuery("#genericStatusModal").modal("show");
            //     setTimeout(() => {
            //         document.querySelector("#genericStatusModal .medium-title").textContent = "";
            //         document.querySelector("#genericStatusModal .message").textContent = "";
            //         jQuery("#genericStatusModal").modal("hide");
            //     }, 2000);
            // }

            document.querySelector("#genericStatusModal .medium-title").textContent = "SENDING";
            document.querySelector("#genericStatusModal .message").textContent = "Please wait..";
            jQuery("#genericStatusModal").modal("show");

            let url = `${Globals.WS_URL}?mode=ASKUS.SUBMIT&token=${token}`;

            const args = {
                method: "POST",
                header: {
                    "Content-Type": "application/x-www-form-urlencoded",
                },
                body: formData,
            };

            if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("Askus - Sending form data");

            fetch(url, args)
                .then(this.handleResponse)
                .then((result) => {
                    if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("Askus - Receive results");
                    if (result.askus) {
                        document.querySelector("#genericStatusModal .message").textContent = "Message sent";
                        setTimeout(() => {
                            window.location.href = window.location.origin + "/find-music";
                        }, 1000);
                    } else {
                        document.querySelector("#genericStatusModal .message").textContent = "Error sending message";
                        setTimeout(() => {
                            document.querySelector("#genericStatusModal .medium-title").textContent = "";
                            document.querySelector("#genericStatusModal .message").textContent = "";
                            jQuery("#genericStatusModal").modal("hide");
                        }, 2000);
                    }
                })
                .catch((error) => {
                    if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("ERROR Askus - Sending form data", { message: error });
                    document.querySelector("#genericStatusModal .message").textContent = "Error: " + error;
                    setTimeout(() => {
                        document.querySelector("#genericStatusModal .medium-title").textContent = "";
                        document.querySelector("#genericStatusModal .message").textContent = "";
                        jQuery("#genericStatusModal").modal("hide");
                    }, 2000);
                });
        }
    }

    promiseTimeout(ms, promise) {
        return new Promise((resolve, reject) => {
            const timer = setTimeout(() => {
                reject(new Error("TIMEOUT"));
            }, ms);

            promise
                .then((value) => {
                    clearTimeout(timer);
                    resolve(value);
                })
                .catch((reason) => {
                    clearTimeout(timer);
                    reject(reason);
                });
        });
    }
}
